module.exports = __webpack_public_path__ + "img/payment.347eec4e.svg";